/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

    import axios from "axios";
    import baseUrl from "..";
    import { authToken, authUserID, axiosInstance } from "../axiosConfig";


const listTubes = async (page: number, size: number, sort: any, order: any, keyword: any, plateStatus: any, fromdate?: string, todate?: string, batchNumber?: any) => {
    try {
        const response = await axiosInstance.get(`${baseUrl}/batches/list_tube?page=${page}&size=${size}&sort=${sort}&order=${order}&plate_status=&batch_status=${plateStatus}&batch_number=${batchNumber || ""}&keyword=${keyword}&from_date=${fromdate}&to_date=${todate}`,
            {
                headers: {
                    'x-auth-token': authToken,
                    'x-userid': authUserID
                }
            });
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error)) {
            return error.response?.data
        }
    }
}

const ListLotsTube = async (page: number, pageSize: number, batch_id: any, lot_id: any, inspectionStatus: string, sort?: any, order?: any) => {
    try {
        const response = await axiosInstance.get(`${baseUrl}/lots/list_lots_tube?page=${page}&size=${pageSize}&sort=${sort}&order=${order}&inspection_status=${inspectionStatus}&batch_no=&batch_id=${batch_id || ""}&lot_id=${lot_id}`,
            {
                headers: {
                    'x-auth-token': authToken,
                    'x-userid': authUserID
                }
            });
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error)) {
            return error.response?.data
        }
    }
};

const listLotTubeDetails = async (page :number, size :number, sort:any , order:any , plateStatus:any, batchId: any, keyword: any, lot_id :any) => {
  try {
      const response = await axiosInstance.get(`${baseUrl}/tubes/list_tube_details?page=${page}&size=${size}&sort=${sort}&order=${order}&status=active&keyword=${keyword}&batch_number=&serial_number=&current_location_id=&location=&incubator_id&lot_id=${lot_id}&lot_code`,
      {
        headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID
        }
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
}

const createTubesV2 = async (dataToSend:any) => {
    try {
      const response = await axiosInstance.post(`${baseUrl}/tubes/v3/create_new_tubes`, 
       dataToSend ,
       {
         headers: {
           'x-auth-token': authToken,
           'x-userid': authUserID
         }
       }
      );
      return response.data;
    }catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
  }
  }

const ListTubeByStatus = async (page :number, size :number,sort :string, order : string, plate_status:string, locationId:any, keyword:any, location: any, master_activities_id?:any, next_process?:any, next_equipment_id?: string, scheduleProductId?: string, productId?: string) => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/tubes/list_tube_details?page=${page}&size=${size}&sort=${sort}&order=${order}&status=active&tube_status=${plate_status}&keyword=${keyword}&current_location_id=${locationId}&area_id=${location}&master_activities_id=${master_activities_id}&next_process_keyword=${next_process}&next_equipment_id=${next_equipment_id}&schedule_production_id=${scheduleProductId}&product_id=${productId}`,
      {
        headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID
        }
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }

const ListTubeIncubationHistory = async (page: number, size: number, sort: string, order: string, keyword: any, areaId: any, scheduleProductId?: string, productId?: string) => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/sterility_incubation/history?page=${page}&size=${size}&sort=${sort}&order=${order}&status=active&keyword=${keyword}&area_master_id=${areaId}&schedule_production_id=${scheduleProductId}&product_id=${productId}`,
      {
        headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID
        }
      });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data
    }
  }
}

const startTubeIncubation = async (dataToSend : any) => {
    try {
      const response = await axiosInstance.post(`${baseUrl}/sterility_incubation/start`, 
       dataToSend,
       {
         headers: {
           'x-auth-token': authToken,
           'x-userid': authUserID
         }
       }
      );
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }

  const endTubeIncubation = async (dataToSend : any) => {
    try {
      const response = await axiosInstance.post(`${baseUrl}/sterility_incubation/stop`, 
       dataToSend,
       {
         headers: {
           'x-auth-token': authToken,
           'x-userid': authUserID
         }
       }
      );
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }

const mediaTubeService = {
    listTubes,
    ListLotsTube,
    listLotTubeDetails,
    createTubesV2,
    ListTubeByStatus,
    startTubeIncubation,
    endTubeIncubation,
    ListTubeIncubationHistory
};

export { mediaTubeService };